module.exports = __webpack_public_path__ + "img/bd7b69d.svg";